import { urls } from 'Constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'
import { ReceivingFileModel } from 'Models'
import { toFormData } from 'Helpers'
import { axiosDS } from '@pp/axios'
import { DocumentBg, DocumentsForSendType } from 'Pages/ibro'

export const bgDocumentApi = {
	downloadDocument: async (id: number) => {
		const res = await axiosDS().get(
			urls.broker.document.replace(':id', id.toString()).concat('/file'),
			{
				responseType: 'blob',
			}
		)
		return res.data
	},

	sendDocumentToEmail: async (id: number, documentType: DocumentsForSendType) => {
		const res = await axiosDS().get<SimpleResponse>(
			urls.broker.send_document.replace(':id', id.toString()).replace(':type', String(documentType))
		)
		return res.data
	},

	sendDocument: async (data: DocumentBg) => {
		const res = await axiosDS().post<ReceivingFileModel>(
			urls.broker.save_document.replace(':id', data.request_id.toString()),
			toFormData(data)
		)
		return res.data
	},

	sendLimitRequestDocument: async (data: DocumentBg) => {
		const res = await axiosDS().post<ReceivingFileModel>(
			urls.broker.save_limit_request_document.replace(':request_id', data.request_id.toString()),
			toFormData(data)
		)
		return res.data
	},

	updateDocument: async (id: number, data: DocumentBg) => {
		const res = await axiosDS().patch<ReceivingFileModel>(
			urls.broker.document.replace(':id', id.toString()),
			toFormData(data)
		)
		return res.data
	},

	deleteDocument: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(
			urls.broker.document.replace(':id', id.toString())
		)
		return res.data
	},
	downloadTrustDocument: async (request_id: number, id: number, filename: string) => {
		const res = await axiosDS().get(
			urls.broker.download_trust_document
				.replace(':request_id', request_id.toString())
				.replace(':id', id.toString())
				.replace(':filename', filename),
			{ responseType: 'blob' }
		)
		return res.data
	},
}
